import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'
// import { getAdminPower } from '@/apiUtils'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/',
			component: () => import('../components/common/Home.vue'),
			meta: { title: '自述文件' },
			children: [
				{
					path: '/home',
					component: () => import('../components/page/Home/index.vue'),
					meta: { title: 'MinerU--PDF文档AI解析' }
				}
			]
		},
		{
			path: '/login',
			component: () => import('@/components/page/Login/index.vue'),
			meta: { title: '登录' }
		}
	]
})

export default router
